import { useState, useEffect, useCallback } from 'react';

const REFRESH_INTERVAL = 15000;

function formatResolutionTime(minutes) {
  if (minutes === null || minutes === undefined) return '--';
  if (minutes < 60) return `${minutes}m`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m > 0 ? `${h}h ${m}m` : `${h}h`;
}

function formatTime(date) {
  return date.toLocaleTimeString('en-US', {
    timeZone: 'America/Chicago',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
  });
}

export default function WidgetPage() {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    document.title = 'Apollo Towing - Live Stats';
  }, []);

  const loadStats = useCallback(async () => {
    try {
      const res = await fetch('/api/public/stats');
      if (!res.ok) throw new Error('Failed');
      const data = await res.json();
      setStats(data);
      setLastUpdated(new Date());
      setError(false);
    } catch {
      setError(true);
    }
  }, []);

  useEffect(() => {
    loadStats();
    const interval = setInterval(loadStats, REFRESH_INTERVAL);
    return () => clearInterval(interval);
  }, [loadStats]);

  return (
    <a href="/" className="widget-page">
      <div className="widget-header">
        <img
          src={`${process.env.PUBLIC_URL}/logo-banner.png`}
          alt="Apollo Towing DFW"
          className="widget-logo"
        />
      </div>
      <div className="widget-body">
        {error && !stats && (
          <div className="widget-error">Unable to load stats</div>
        )}
        {stats && (
          <div className="widget-cards">
            <div className="widget-card">
              <span className="widget-value widget-value-open">
                {stats.total_calls}
              </span>
              <span className="widget-label">Total Calls</span>
            </div>
            <div className="widget-card">
              <span className="widget-value widget-value-claimed">
                {stats.claimed_calls}
              </span>
              <span className="widget-label">Claimed</span>
            </div>
            <div className="widget-card">
              <span className="widget-value widget-value-time">
                {formatResolutionTime(stats.avg_resolution_minutes)}
              </span>
              <span className="widget-label">Avg Resolution</span>
              <span className="widget-sublabel">This shift</span>
            </div>
          </div>
        )}
      </div>
      <div className="widget-footer">
        {lastUpdated && (
          <span className="widget-updated">
            Updated {formatTime(lastUpdated)} CT
          </span>
        )}
        {error && stats && (
          <span className="widget-offline">Connection lost — retrying...</span>
        )}
      </div>
    </a>
  );
}
